import type { Cable } from '@anycable/web'
import { createCable } from '@anycable/web'

export default createCable({ protocol: 'actioncable-v1-ext-json' }) as Cable
